<div *ngIf="cs.isBrowser" [formGroup]="form" class="form-group">
  <label>{{ field.label }}{{ field.validation?.required ? '*' : '' }}</label>
  <input
    class="form-control"
    [ngxTimepicker]="toggleIcon"
    [disableClick]="false"
    [placeholder]="field.placeholder"
    [formControlName]="field.name"
    [ngxTimepicker]="toggleIcon"
    [min]="field.minTime"
    autocomplete="off"
  />
  <ngx-material-timepicker-toggle [for]="toggleIcon">
    <em 
      ngxMaterialTimepickerToggleIcon
      class="icon-litetime-watch time-icon-position"
    ></em>
  </ngx-material-timepicker-toggle>
  <ngx-material-timepicker #toggleIcon></ngx-material-timepicker>
  <app-validation-errors
    [control]="form.get(field.name)"
    [field]="field"
  ></app-validation-errors>
</div>
